"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ProtoDefs_js_1 = require("./ProtoDefs.js");
// todo: dynamically create this type from protobuf
class MsgData {
    constructor(msgType, data) {
        this.msgType = msgType;
        this.data = data;
    }
}
exports.MsgData = MsgData;
function decodeTxData(data) {
    const message = ProtoDefs_js_1.cosmos.base.abci.v1beta1.TxMsgData.decode(data);
    const object = ProtoDefs_js_1.cosmos.base.abci.v1beta1.TxMsgData.toObject(message, {
        longs: String,
        enums: String,
        bytes: String,
    });
    return object["data"].map((item) => {
        var _a;
        return new MsgData(item.msgType, (_a = item) === null || _a === void 0 ? void 0 : _a.data);
    });
}
exports.decodeTxData = decodeTxData;
//# sourceMappingURL=ProtoEncoding.js.map